/* global $:false */
(function() {
  'use strict';

  angular
    .module('admin.checklistempty.edit', [
    ])
    .controller('ChecklistEmptyStateEditCtrl', ChecklistEmptyStateEditCtrl);

  /** @ngInject */
  function ChecklistEmptyStateEditCtrl($state, $q, $stateParams, $timeout, TranslatorService, PostsAdminService, UploadService, ChecklistService) {
    var vm = this;
    vm.model = {};
    vm.id = parseInt($stateParams.id);
    vm.pathImg = "";

    vm.checklistTranslations = [];
    function loadTranslations(){
      ChecklistService.listTranslationsEmptyState($stateParams.id).then(function(result){
        vm.checklistTranslations = result.results;
      });
    }
    loadTranslations();

    // var makeTranslation = function(t, txt, currentTranslations, paramsId, route) {
    //   if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
    //     if (vm.title === t && vm.description === txt) {
    //         $state.go(route);
    //         return
    //     }
    //   }

    //   TranslatorService.translateChecklist(t, txt).then(function(res) {
    //     var languages = [
    //       'ja',
    //       'ko',
    //       'zh',
    //       'zh-TW'
    //     ]

    //     for (var i = 0; i < currentTranslations.length; i++) {
    //       for (var key in res.t.results) {
    //         if ((currentTranslations[i].comm === 'JP' && key.indexOf('ja') !== -1)) {
    //           languages.remove('ja')
    //         }
    //         if ((currentTranslations[i].comm === 'KR' && key.indexOf('ko') !== -1)) {
    //           languages.remove('ko')
    //         }
    //         if ((currentTranslations[i].comm === 'SC' &&  key.indexOf('zh') !== -1)) {
    //           languages.remove('zh')
    //         }
    //         if ((currentTranslations[i].comm === 'TC' &&  key.indexOf('zh-TW') !== -1)) {
    //           languages.remove('zh-TW')
    //         }
    //       }
    //     }


    //     if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
    //       var promises = []

    //       for (var i = 0; i < currentTranslations.length; i++) {
    //         if (currentTranslations[i].comm === 'SC' && res.t.results) {
    //           var exist = _.find(languages, 'zh');
    //           if (exist) {
    //             promises.push(ChecklistService.saveTranslationEmptyState(paramsId, {
    //               'id-u': 0,
    //               comm: 'SC',
    //               l1: res.t.results.zh,
    //               l2: res.txt ? res.txt.results.zh : '',
    //             }))
    //           } else {
    //             promises.push(ChecklistService.updateTranslationEmptyState(currentTranslations[i].id, {
    //               'id-u': 0,
    //               l1: res.t.results.zh,
    //               l2: res.txt ? res.txt.results.zh : '',
    //             }))
    //           }
    //           continue
    //         }
    //         if (currentTranslations[i].comm === 'TC' && res.t.results) {
    //           var exist = _.find(languages, 'zh-TW');
    //           if (exist) {
    //             promises.push(ChecklistService.saveTranslationEmptyState(paramsId, {
    //               'id-u': 0,
    //               comm: 'TC',
    //               l1: res.t.results['zh-TW'],
    //               l2: res.txt ? res.txt.results['zh-TW'] : '',
    //             }))
    //           } else {
    //             promises.push(ChecklistService.updateTranslationEmptyState(currentTranslations[i].id, {
    //               'id-u': 0,
    //               l1: res.t.results['zh-TW'],
    //               l2: res.txt ? res.txt.results['zh-TW'] : '',
    //             }))
    //           }
    //           continue
    //         }
    //         if (currentTranslations[i].comm === 'KR' && res.t.results) {
    //           var exist = _.find(languages, 'ko');
    //           if (exist) {
    //             promises.push(ChecklistService.saveTranslationEmptyState(paramsId, {
    //               'id-u': 0,
    //               comm: 'KR',
    //               l1: res.t.results.ko,
    //               l2: res.txt ? res.txt.results.ko : '',
    //             }))
    //           } else {
    //             promises.push(ChecklistService.updateTranslationEmptyState(currentTranslations[i].id, {
    //               'id-u': 0,
    //               l1: res.t.results.ko,
    //               l2: res.txt ? res.txt.results.ko : '',
    //             }))
    //           }
    //           continue
    //         }
    //         if (currentTranslations[i].comm === 'JP' && res.t.results) {
    //           var exist = _.find(languages, 'ja');
    //           if (exist) {
    //             promises.push(ChecklistService.saveTranslationEmptyState(paramsId, {
    //               'id-u': 0,
    //               comm: 'JP',
    //               l1: res.t.results.ja,
    //               l2: res.txt ? res.txt.results.ja : '',
    //             }))
    //           } else {
    //             promises.push(ChecklistService.updateTranslationEmptyState(currentTranslations[i].id, {
    //               'id-u': 0,
    //               l1: res.t.results.ja,
    //               l2: res.txt ? res.txt.results.ja : '',
    //             }))
    //           }
    //           continue
    //         }
    //       }

    //       $q.all(promises).then(function(){
    //         $state.go(route);
    //       }).catch(function(err){
    //         swal("Error in translation, please send message to qp2 administrator!", "", "error");
    //       })
    //     }

    //     var promises = []

    //     for (var i = 0; i < languages.length; i++) {
    //       if (languages[i] === 'zh' && res.t.results) {
    //         promises.push(ChecklistService.saveTranslationEmptyState(paramsId, {
    //           'id-u': 0,
    //           comm: 'SC',
    //           l1: res.t.results.zh,
    //           l2: res.txt ? res.txt.results.zh : '',
    //         }))
    //       }
    //       if (languages[i] === 'zh-TW' && res.t.results) {
    //         promises.push(ChecklistService.saveTranslationEmptyState(paramsId, {
    //           'id-u': 0,
    //           comm: 'TC',
    //           l1: res.t.results['zh-TW'],
    //           l2: res.txt ? res.txt.results['zh-TW'] : '',
    //         }))
    //       }
    //       if (languages[i] === 'ko' && res.t.results) {
    //         promises.push(ChecklistService.saveTranslationEmptyState(paramsId, {
    //           'id-u': 0,
    //           comm: 'KR',
    //           l1: res.t.results.ko,
    //           l2: res.txt ? res.txt.results.ko : '',
    //         }))
    //       }
    //       if (languages[i] === 'ja' && res.t.results) {
    //         promises.push(ChecklistService.saveTranslationEmptyState(paramsId, {
    //           'id-u': 0,
    //           comm: 'JP',
    //           l1: res.t.results.ja,
    //           l2: res.txt ? res.txt.results.ja : '',
    //         }))
    //       }
    //     }

    //     $q.all(promises).then(function(){
    //       $state.go(route);
    //     }).catch(function(){
    //       swal("Error in translation, please send message to qp2 administrator!", "", "error");
    //     })
    //   });
    // }

    if (vm.id !== 0) {
      ChecklistService.getEmptyState($stateParams.id).then(function(result){
        vm.model = result.results;
      });
    }

    vm.save = function(){
      var model = angular.copy(vm.model);
      if (!model.img) {
        swal('Required image', '', 'error');
        return;
      }

      if (!model.l1) {
        swal('Required line1', '', 'error');
        return;
      }

      if (!model.l2) {
        model.l2 = ""
      }

      if (model.id !== undefined && model.id !== '' && model.id !== 0) {
        ChecklistService.updateEmptyState(model.id, model).then(function(){
          // makeTranslation(model.l1, model.l2, vm.checklistTranslations, model.id, 'admin.checklist')
          $state.go('admin.checklist')
        }, function(err) {
          $timeout(function() {
            swal(err.error.message, "", "error");
          }, 250);
        });
      } else {
        ChecklistService.saveEmptyState(model).then(function(result){
          // makeTranslation(model.l1, model.l2, vm.checklistTranslations, result.results.id, 'admin.checklist')
          $state.go('admin.checklist');
        }, function(err) {
          $timeout(function() {
            swal(err.error.message, "", "error");
          }, 250);
        });
      }
    };

    vm.cancel = function() {
      $state.go('admin.checklist');
    };

    vm.uploadImage = function(item) {
      vm.loadImg = true;
      UploadService.save("checklists", vm.pathImg, "img", !item.id ? 0 : item.id).then(function(
        fileName
      ) {
        vm.loadImg = false;
        item["img"] = fileName;
      });
    };

    vm.translate = {};
    vm.pathImgTranslation = "";
    vm.loadTranslation = false;
    vm.addTranslate = function(){
      vm.translate = {};
      $("#modalTranslate").modal("show");
    };

    vm.classDisabled = function(){
      if (!vm.translate.comm || !vm.translate.l1){
        return 'is-disabled';
      } else {
        return;
      }
    };

    vm.saveTranslate = function() {
      if (vm.translate.id) {
        ChecklistService.updateTranslationEmptyState(vm.translate.id, vm.translate).then(function(){
          loadTranslations();
          vm.translate = {};
          $("#modalTranslate").modal("hide");
        }, function(err){
          swal(err.error.message, "", "error");
        });
      } else {
        ChecklistService.saveTranslationEmptyState($stateParams.id, vm.translate).then(function(){
          loadTranslations();
          vm.translate = {};
          $("#modalTranslate").modal("hide");
        }, function(err){
          swal(err.error.message, "", "error");
        });
      }
    };

    vm.editTranslate = function(id) {
      ChecklistService.getTranslationEmptyState(id).then(function(result){
        vm.translate = result.results;
        $("#modalTranslate").modal("show");
      }, function(err){
        swal(err.error.message, "", "error");
      });
    };

    vm.deleteTranslate = function(id) {
      swal({
        title: "Are you sure?",
        text: "",
        type: "warning",
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: "slide-from-top"
      }, function(isConfirm){
        if (isConfirm){
          ChecklistService.removeTranslationEmptyState(id).then(function(){
            loadTranslations();
            vm.translate = {};
            $("#modalTranslate").modal("hide");
          }, function(err){
            $timeout(function(){
              swal(err.error.message, "", "error");
            }, 500);
          });
        } else {
          return;
        }
      });
    };

    vm.uploadTranslation = function(item) {
      vm.loadTranslation = true;
      UploadService.save("checklists", vm.pathImgTranslation, "img", item.id).then(function(
        fileName
      ) {
        vm.loadTranslation = false;
        item.img = fileName;
      });
    };
  }

})();
